var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAASUlEQVR42mMYBfjB////z4Aw2Zq3bN4MxiA2WZp7urtBGG4IKZqxYpAcQc2EMWGXpBGDaeMCoGTaqlWrZhHCYBfgAcbE4GGU3AHe4KzwCbhXgQAAAABJRU5ErkJggg==";
  export default img;